import React from "react";


const FepSvcKindSet = (FepSvcKind:string) => {
    switch(FepSvcKind){
        case    '/':
    		FepSvcKind = 'MAIN';
    		break;
        case    '/ssomembjoin':
        case    '/membjoin':
        case    '/membjoin/membjoinform':
        case    '/membjoin/membjoindone':
        case '/membfindpw':
        case '/membfindpw/findpwinput':
        case '/membfindid':
        case '/membfindid/list':
        case    '/connect/ssomembjoin':
        case    '/connect/membjoin':
        case    '/connect/membjoinform':
        case    '/connect/membjoindone':
        case '/connect/membfindpw':
        case '/connect/membfindpw/findpwinput':
        case '/connect/membfindid':
        case '/connect/membfindid/list':
    		FepSvcKind = 'MEMB';
    		break;
        case '/login':
        case '/gamelogin':
        case '/otpathn':
        case '/blckmemb':
        case '/drmcmemb':
        case '/memblvdcncl':
        case '/connect/login':
        case '/connect/gamelogin':
        case '/connect/otpathn':
        case '/connect/blckmemb':
        case '/connect/drmcmemb':
        case '/connect/memblvdcncl':
    		FepSvcKind = 'LOGIN';
    		break;
        case '/mypage':
        case '/mypage/otpreg':
        case '/mypage/otpreginput':
        case '/mypage/idntmthdchng':
        case '/mypage/ingameidntmthdchng':
        case '/mypage/ingameidntmthdsuss':
        case '/mypage/emlchng':
        case '/mypage/emlchnginput':
        case '/mypage/passwdchng':
        case '/mypage/passwdchnginput':
        case '/mypage/memblvd':
        case '/mypage/gamesvcmnydpstlst':
        case '/mypage/gamesvcgiftodrlst':
        case '/mypage/gamesvcrellst':
        case '/mypage/gamesvcitemodrlst':
        case '/mypage/ntfymsglst':
        case '/mypage/qnalst':
        case '/mypage/qnactxt':
        case '/mypage/qnawrite':
        case '/mypage/eml':
        case '/mypage/idntmthdreathn':          
        case '/connect/mypage/emlchng':
        case '/connect/mypage/emlchnginput':
        case '/connect/mypage/passwdchng':
        case '/connect/mypage/passwdchnginput':
        case '/connect/mypage/memblvd':
        case '/connect/mypage/nicknamechnginput':
        case '/connect/mypage/idntmthdchng':
        FepSvcKind = 'MYPAGE'; 
        break;
        case '/emlathnpop':
        FepSvcKind = "EML";
        break;
        case '/cs/main':
        case '/cs/faqlst':
        case '/cs/qnalst':
        case '/cs/qnactxt':
        case '/cs/qnawrite':
        FepSvcKind = "CS";
        break;
        //FepSvcKind='FIND';
        //break;
        case '/gamepage':
        case '/gamepage/ctnt/ctntctxt':
        case '/gamepage/ctnt/ctntlst':
        case '/gamepage/gameguide':
        case '/gamepage/gameprbb':
        case '/gamepage/shoplst':
        case '/gamepage/shopctnt':
        case '/gamepage/gamecupn':
        case '/gamepage/download':
        case '/gamelnchstrt':
        case '/gamemnydpstresult':
        FepSvcKind='GAME';
        break;
      default:
        FepSvcKind = 'MAIN';
        break;
    }
    return FepSvcKind;
    // 소문자로 적어야함!!!!!!!
}

export default FepSvcKindSet;